/* eslint-disable no-nested-ternary */
/* eslint-disable import/prefer-default-export */
import { format } from 'date-fns';
import common from '../_common/common_attendance';

const datasetParams = {
  mainFile: 'Attendance/Outputs/xl_data/Attendance_xl_data_justPY.csv',
  runDetailsFile: 'Attendance/Outputs/xl_data/Attendance_xl_data_justPY_runDetails.csv',
  tableName: 'Attendance_xl',
  mainDateField: 'Date',
  headersRemaps: {
    AdmissionRevenue: 'AdmissionRevenues',
    Budget_Attendance: 'BudgetAttendance',
    Budget_Admission_Revenue: 'BudgetAdmissionRevenues',
    Category: 'ProductType',
    Weather_Code: 'WeatherCode',
    Attendance_Category: 'AttendanceCategory',
    Marketing_Category: 'MarketingCategory',
  },
  calculatedMetrics: common.attendance_calculatedMetrics,
  metrics: common.attendance_metrics,
  valuesRemaps: {
    ProductType: {
      'MDT/MPT': 'MDT',
    },
  },
  transformRow: (row) => ({
    ...row,
    Date: format(new Date(row.Date), 'yyyy-MM-dd'),
    Year: format(new Date(row.Date), 'yyyy'),
    YearMonth: format(new Date(row.Date), 'yyyy-MM'),
    ProductCategory: ['SDT', 'MDT'].includes(row.ProductType) ? 'Discrete' : ['FC', 'Fun Card', 'Pass'].includes(row.ProductType) ? 'Pass' : 'Free',
  }),
  filterDimensions: {
    ...common.attendance_filterDimensions,
    AttendanceCategory: {
      order: 'desc',
    },
    MarketingCategory: {
      order: 'desc',
    },
  },
};

export default datasetParams;
